import { Grid, Icon, IconButton, makeStyles, Typography } from "@material-ui/core"
import DeleteButton from "../../../../components/Actions/DeleteButton"
import RoundedButton from "../../../../components/Actions/RoundedButton"
import SimpleCard from "../../../../components/Structure/Cards/SimpleCard"


const MiniTable = props => {

    const { content, rows, actions, can_edit} = props
    const classes = useStyles()

    return(
        <SimpleCard>      
            {rows && rows.length ?
                <div className={classes.rows}>
                    <div className={classes.header}>
                    <Grid container spacing={3}>
                        <Grid item xs={2}>{content.id}</Grid>
                        <Grid item xs={2}>{content.code}</Grid>
                        <Grid item xs={2}>{content.brand}</Grid>
                        <Grid item xs>{content.description}</Grid>
                    </Grid>
                    </div>
                    {rows.map(item => {
                        return(
                            <Row {...item} key={item.id_product} can_edit={can_edit} onDelete={()=>actions.onDeleteProduct(item.id_product)}  />
                        )
                    })}
                </div>
            : null}
        </SimpleCard>
    )
}

export default MiniTable

const useStyles = makeStyles(theme => ({
    rows:{
        marginTop:40
    },
    header:{
        font:theme.typography.fontFamily,
        fontSize:'0.875rem',
        color:'#909090',
        fontWeight:500
    },
}))

const Row = ({id_product, code, brand, name, onDelete, can_edit}) => {

    const classes = useStylesRow()

    return(
        <div className={classes.root}>
            <Grid container spacing={3} alignItems='center'>
                <Grid item xs={2}>{id_product}</Grid>
                <Grid item xs={2}>{code}</Grid>
                <Grid item xs={2}>{brand}</Grid>
                <Grid item xs>{name}</Grid>
                {can_edit ? <Grid item><DeleteButton  onClick={onDelete} /></Grid> :null}
            </Grid>
        </div>
    )
}

const useStylesRow = makeStyles(theme => ({
    root:{
        borderBottom:'1px solid #D2D2D2',
        padding:'16px 0px',
        font:theme.typography.fontFamily,
        fontWeight:500
    },
    delete_button:{
        boxShadow:'0px 0px 2.86957px rgba(0, 0, 0, 0.25)',
        color:theme.palette.primary.main,
    },
    
}))



